type CategoryIconKind = 'cup' | 'pizza' | 'fitness' | 'care' | 'retail' | 'services' | 'store';

const categoryIconFragments: Record<CategoryIconKind, string> = {
  cup: '<path d="M5 8h11v5.2A5.8 5.8 0 0 1 10.2 19H10A5 5 0 0 1 5 14V8Z"/><path d="M16 10h1.4a2.6 2.6 0 0 1 0 5.2H16M4 21h14M8 5c-1.2-1.2.8-2.1 0-3.2M12 5c-1.2-1.2.8-2.1 0-3.2"/>',
  pizza: '<path d="m4 20 16-16c-5.3-1.8-10.7-1-14.4 2.6C2 10.3 2.1 15.8 4 20Z"/><path d="M7.2 7.4 16.6 17M9 11.2h.01M13.2 8.2h.01M7.3 15.7h.01"/>',
  fitness: '<path d="M3 9v6M6 7v10M18 7v10M21 9v6M6 12h12"/>',
  care: '<circle cx="7" cy="7" r="3"/><circle cx="7" cy="17" r="3"/><path d="m9.5 8.7 10 7.3M9.5 15.3l10-7.3M15 12l4 8"/>',
  retail: '<path d="M6 8h12l1 13H5L6 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/>',
  services: '<path d="m14.5 6.5 3-3 3 3-3 3M9.5 17.5l-3 3-3-3 3-3M13 8l3 3M8 13l3 3"/><circle cx="12" cy="12" r="3"/>',
  store: '<path d="M4 9h16l-1.4-5H5.4L4 9Z"/><path d="M5.5 9v11h13V9M9 20v-6h6v6"/>',
};

export function categoryIconKind(value?: string | null): CategoryIconKind {
  const normalized = (value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  if (/pizza|pizzeria/.test(normalized)) return 'pizza';
  if (/caffe|cafe|bar|ristor|food|bakery|panific|pastic|gelat|brunch/.test(normalized)) return 'cup';
  if (/palestr|fitness|gym|pilates|sport|fisioter/.test(normalized)) return 'fitness';
  if (/cura|estetic|parruc|barber|salon|bellezza|persona/.test(normalized)) return 'care';
  if (/retail|negoz|shop|abbigli|clothing|borsa|librer/.test(normalized)) return 'retail';
  if (/serviz|lavander|auto|officin|ripar|tool/.test(normalized)) return 'services';
  return 'store';
}

export function categoryIconMarkup(value?: string | null) {
  const fragment = categoryIconFragments[categoryIconKind(value)];
  return `<svg class="category-glyph" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${fragment}</svg>`;
}

export function CategoryIcon({ category, className = '' }: { category?: string | null; className?: string }) {
  return <span className={`category-icon${className ? ` ${className}` : ''}`} aria-hidden="true" dangerouslySetInnerHTML={{ __html: categoryIconMarkup(category) }} />;
}

export function RadarEyeVisual({ className = '', label }: { className?: string; label?: string }) {
  return <figure className={`radar-eye${className ? ` ${className}` : ''}`} aria-hidden={label ? undefined : true} aria-label={label}>
    <svg viewBox="0 0 220 170" role={label ? 'img' : undefined}>
      <g className="radar-eye-orbits">
        <ellipse cx="112" cy="83" rx="94" ry="57"/>
        <ellipse cx="112" cy="83" rx="70" ry="43"/>
        <ellipse cx="112" cy="83" rx="47" ry="29"/>
        <path d="M10 111 54 96l34 13 45-42 37 11 40-47"/>
        <circle cx="54" cy="96" r="3"/><circle cx="88" cy="109" r="3"/><circle cx="133" cy="67" r="3"/><circle cx="170" cy="78" r="3"/><circle cx="210" cy="31" r="3"/>
      </g>
      <g className="radar-eye-mark">
        <path d="M61 83c14-21 30-31 51-31s38 10 52 31c-14 21-31 31-52 31S75 104 61 83Z"/>
        <circle cx="112" cy="83" r="19"/>
        <circle cx="105" cy="76" r="5"/>
      </g>
    </svg>
  </figure>;
}
